import axios from '~/utils/axios';

const getListPublicationsApi = (param) => axios.get('ai-landing/getListPublications', {params: param});

export default {
    getListPublicationsApi
};
